import Divider from "@mui/material/Divider";
import styled from "styled-components";

export const StyledDivider = styled(Divider)``;
